import { gql } from 'apollo-angular';

export default gql`
  query relationTypes($tenantUri: String!, $spaceUri: String) {
    relationTypes(tenantUri: $tenantUri, spaceUri: $spaceUri) {
      __typename
      uri
      tenantUri
      label
      universal
      version
      createdOn
      createdByUri
      updatedOn
      updatedByUri
      inverseRelation {
        uri
        tenantUri
        label
        # version
        # createdOn
        # createdByUri
        # updatedOn
        # updatedByUri
      }
      relationTypeRanges {
        ownerElementTypeUri
        acceptorElementTypeUri
      }
    }
  }
`;
